import { Paragraph, ImageRun, AlignmentType } from "docx";
import uploadFileService from "../../../services/uploadFile.service";

const ImagePrint = async ({ fileId, imageSetting }) => {
  const width = imageSetting?.width ?? 400;
  const height = imageSetting?.height ?? 300;

  try {
    const imageUrl = await uploadFileService.loadImage2(fileId);

    // Kthe imazhin në Uint8Array nga arrayBuffer
    const response = await fetch(imageUrl);
    const arrayBuffer = await response.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);

    const imageParagraph = new Paragraph({
      alignment: AlignmentType.CENTER,
      children: [
        new ImageRun({
          data: uint8Array, // shumë e rëndësishme për Word Online
          transformation: { width, height },
        }),
      ],
    });

    return imageParagraph;
  } catch (error) {
    console.error("Failed to load or convert image:", error);
    return null;
  }
};

export default ImagePrint;
